'use strict';

function init () {
  var isInDevEnv = window.wooGlobal.env === 'dev';
  var ravenURL = isInDevEnv ? false : 'https://4b5a02a953224012a1877029da8ae180@app.getsentry.com/40969';
  var ravenSettings = isInDevEnv ? {} : {
    release: '6.0.0',
    whitelistUrls: window.wooGlobal.cdn || ''
  };

  // Raven Events
  if (window.wooGlobal.cdn) {
    // Remove slashes in cdn
    window.wooGlobal.cdn.replace(/\//g, '');
  }

  if (window.Raven !== undefined && !isInDevEnv) {
    window.Raven.config(ravenURL, ravenSettings);
    window.Raven.debug = false;
    window.Raven.install();

    if (window.wooGlobal.user) {
      return window.Raven.setUserContext({
        id: window.wooGlobal.user.id
      });
    }
  } else {
    // prevent use from checking window.Raven in all other scripts that use it
    window.Raven = {
      captureMessage: function () {}
    };
  }
}

module.exports.init = init;
